const en = {
  'common.SEARCH': 'Search',
  'home.WELCOME_TITLE': 'Welcome!',
  'home.WELCOME_MESSAGE': 'Hello partner! How are you?',
  'home.WEATHER_TEXT': 'Let me tell you the weather.',
  'home.SEARCH_CITY': 'Enter a city name',
  'weather.TEMPERATURE_DISPLAY': '{temperature}° F',
  'weather.DAY': 'Day',
  'weather.NIGHT': 'Night',
};

export default en;
